import ReportsApi from '../../apis/Reports';

export default {
    namespaced: true,
    state: {
        transfers: [],
        filters: null,
        transfer: null,
        detail: [],
        file_excel: null,
        paginated:{},
        filter: {}
    },
    mutations: {
        set_transfers (state, data) {
            state.transfers = data
        },
        set_filters (state, data) {
            state.filters = data;
        },
        set_transfer (state, data) {
            state.transfer = data;
        },
        set_detail (state, data) {
            state.detail = data;
        },
        set_file_excel (state, value) {
            state.file_excel = value;
        },
        set_paginated (state, data) {
            state.paginated =  data
        },
        set_filter(state, data) {
            state.filter = data
        }
    },
    actions: {
        setTransfers ({commit}, data) {
            commit('set_transfers', data);
        },
        setFilters ({commit}, data) {
            commit('set_filters', data);
        },
        selectTransfer ({commit}, data) {
            commit('set_transfer', data);
        },
        async getTransfers({commit, dispatch}, filters) {
            commit('set_transfers', []);
            return await ReportsApi.getTransfers(filters)
                        .then( response => {
                            commit('set_transfers', response.data);
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al listar transferecias, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
        async getTransfersPaginated({commit, dispatch}, filters) {
            commit('set_transfers', []);
            return await ReportsApi.getTransfersPaginated(filters)
                        .then( response => {
                            commit('set_paginated', {
                                ...response.data
                            })
                            commit('set_transfers', response.data.data)
                            // commit('set_transfers', response.data);
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al listar transferecias, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
        async getTransferDetail({commit, dispatch}, transfer) {
            commit('set_detail', []);
            return await ReportsApi.getTransferDetail(transfer)
                        .then( response => {
                            commit('set_detail', response.data);
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al listar detalle de transferencia, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
        async transferExcel({commit, dispatch}, filters) {
            commit('set_file_excel', null);
            return await ReportsApi.transferExcel(filters)
                        .then( response => {
                            commit('set_file_excel', response.data.file_excel);
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al descargar reporte de transferencias, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
        async transferDetailExcel({commit, dispatch}, transfer) {
            commit('set_file_excel', null);
            return await ReportsApi.transferDetailExcel(transfer)
                        .then( response => {
                            commit('set_file_excel', response.data.file_excel);
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al descargar detalle de transferencia, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
    }
}